export default "__VITE_ASSET__d3TAor5W__"